export default __webpack_public_path__ + "static/subset-DrukTextWideCyr-Medium-151eef339b389c57ca789ff51d9a7224.woff2";